import { ImageMessageFieldsFragment, ImageMessageInput } from '@anyx/common-graphql';
import { TrackingUrlArray, toUploadImageFile } from '@anyx/feature-crm/shared';
import { URLUtils } from '@anyx/shared-utils';

import { getManualActionURL, ImageTypeBlock, LineMessageBlockType } from '../../components';

import { UrlActionAdapter } from './url-action-adapter';

type ImageContent = {
  imageMessage: ImageMessageInput;
};

type ImagesAdapter = {
  toGQL: (message: ImageTypeBlock) => ImageContent;
  toOriginalUrls: (message: ImageTypeBlock, trackingUrls: TrackingUrlArray) => string[];
  toMessageBlock: (content: ImageMessageFieldsFragment) => ImageTypeBlock;
};

export const imagesAdapter: ImagesAdapter = {
  toGQL: ({ cards }) => ({
    imageMessage: {
      images: cards.map((card) => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const image = card.image!;

        return {
          imageUrl: image.src,
          label: card.actionLabel || undefined,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          urlAction: UrlActionAdapter.toGQL(card.actionUrl)!,
        };
      }),
    },
  }),
  toOriginalUrls: ({ cards }, trackingUrls) =>
    cards
      .map((card) => {
        const originalUrl = trackingUrls.find(
          ({ trackingUrl }) => trackingUrl === getManualActionURL(card.actionUrl)
        )?.originalUrl;

        return originalUrl ? URLUtils.encode(originalUrl) : undefined;
      })
      .filter((url) => url !== undefined) as string[],
  toMessageBlock: ({ images }) => ({
    type: LineMessageBlockType.enum.IMAGES,
    cards: images.map((image) => ({
      image: toUploadImageFile(image.imageUrl),
      actionLabel: image.label ?? '',
      actionUrl: UrlActionAdapter.toMessageBlock(image.urlAction ?? undefined),
    })),
  }),
};
